import { createContext, useContext, useEffect, useState } from "react";

const StoreContext = createContext(null);

const load = (k, d) => {
  try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; }
};

export const StoreProvider = ({ children }) => {
  const [cart, setCart] = useState(() => load("bdc_cart", []));
  const [favorites, setFavorites] = useState(() => load("bdc_favorites", []));
  const [cartOpen, setCartOpen] = useState(false);

  useEffect(() => { localStorage.setItem("bdc_cart", JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem("bdc_favorites", JSON.stringify(favorites)); }, [favorites]);

  const addToCart = (p, qty = 1, variant = null) => {
    const key = `${p.slug}|${variant || ""}`;
    const price = p.sale_price ?? p.price;
    setCart((c) => {
      const ex = c.find((i) => i.key === key);
      if (ex) return c.map((i) => (i.key === key ? { ...i, qty: Math.min(i.qty + qty, p.stock) } : i));
      return [...c, { key, slug: p.slug, name: p.name, sku: p.sku, price, image: p.images[0], variant, qty, stock: p.stock }];
    });
  };
  const updateQty = (key, qty) =>
    setCart((c) => (qty <= 0 ? c.filter((i) => i.key !== key) : c.map((i) => (i.key === key ? { ...i, qty: Math.min(qty, i.stock) } : i))));
  const removeFromCart = (key) => setCart((c) => c.filter((i) => i.key !== key));
  const clearCart = () => setCart([]);

  const isFavorite = (slug) => favorites.some((f) => f.slug === slug);
  const toggleFavorite = (p) =>
    setFavorites((f) => (f.some((x) => x.slug === p.slug) ? f.filter((x) => x.slug !== p.slug) : [...f, p]));

  const cartCount = cart.reduce((s, i) => s + i.qty, 0);
  const cartTotal = cart.reduce((s, i) => s + i.qty * i.price, 0);

  return (
    <StoreContext.Provider
      value={{ cart, addToCart, updateQty, removeFromCart, clearCart, cartCount, cartTotal, cartOpen, setCartOpen, favorites, isFavorite, toggleFavorite }}
    >
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => useContext(StoreContext);
